import http from '@/utils/http';

export function getWxMsg(key) {
  return http.get(`/txn/webChatMsg/${key}`);
}
